import { createProviderReviewsState } from "@/controllers/reviewsState";
import providerReviewsLifecycle from "@/controllers/reviewsLifecycle";
import providerReviewsDataMethods from "@/controllers/reviewsDataMethods";
import providerReviewsViewMethods from "@/controllers/reviewsViewMethods";
import providerReviewsReplyMethods from "@/controllers/reviewsReplyMethods";

export default {
  data() {
    return createProviderReviewsState();
  },
  ...providerReviewsLifecycle,
  methods: {
    ...providerReviewsDataMethods,
    ...providerReviewsViewMethods,
    ...providerReviewsReplyMethods,
  },
};
